export const AI_PROMPTS_SUBTAB_CAPS = {
  models: 'ai_models_selector',
  sourceOfTruth: 'admin_panel_ai_prompts',
  jtbd: 'admin_panel_ai_prompts',
  tension: 'admin_panel_ai_prompts',
  recipeAttributes: 'admin_panel_ai_prompts',
  writtenConcept: 'admin_panel_ai_prompts',
  visualConcept: 'admin_panel_ai_prompts',
} as const;

export type AiPromptsSubtabKey =
  | 'models'
  | 'source_of_truth'
  | 'jtbd'
  | 'tension'
  | 'recipe_attributes'
  | 'written_concept'
  | 'visual_concept';
